import { Phone, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Reveal } from "@/components/landing/Reveal";
import { BRAND } from "@/data/content";
import { useQuote } from "@/context/QuoteContext";

const FinalCTA = () => {
  const { openQuote } = useQuote();
  return (
    <section id="contact" className="py-16 md:py-24" data-testid="final-cta-section">
      <div className="max-shell mx-auto px-4 md:px-8 lg:px-12">
        <Reveal>
          <div className="relative overflow-hidden rounded-[28px] shadow-glass">
            <img
              src="https://images.unsplash.com/photo-1783260606332-23546f99b8c8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600"
              alt="Aerial drone view of a large rooftop solar panel installation"
              loading="lazy"
              className="absolute inset-0 h-full w-full object-cover"
            />
            <div className="absolute inset-0 bg-brand-navy/80" />
            <div className="relative px-6 py-16 md:px-16 md:py-24 text-center">
              <h2 className="text-3xl md:text-[44px] leading-tight font-bold text-white max-w-3xl mx-auto text-balance">
                Ready To Start Saving On Electricity?
              </h2>
              <p className="mt-4 text-base md:text-lg text-slate-200 max-w-xl mx-auto leading-[1.8]">
                Get a free, no-obligation assessment and a system designed around your actual energy needs.
              </p>
              <div className="mt-9 flex flex-col sm:flex-row gap-3 justify-center">
                <Button
                  onClick={() => openQuote("final-cta")}
                  data-testid="final-cta-quote"
                  className="h-14 rounded-full bg-brand-yellow text-brand-navy font-semibold text-base px-8 hover:bg-[#f0bd1f] hover:-translate-y-0.5 transition-transform shadow-soft group"
                >
                  Get Free Quote
                  <ArrowRight className="ml-1 h-5 w-5 group-hover:translate-x-1 transition-transform" />
                </Button>
                <Button
                  asChild
                  variant="outline"
                  data-testid="final-cta-call"
                  className="h-14 rounded-full border-[1.5px] border-white/60 bg-transparent text-white font-semibold text-base px-8 hover:bg-white/10 transition-colors"
                >
                  <a href={`tel:${BRAND.phoneRaw}`}>
                    <Phone className="mr-1 h-5 w-5" /> Call Now
                  </a>
                </Button>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default FinalCTA;
